import React from 'react';
import PropTypes from 'prop-types';

import { FilePropType } from 'propTypes/common';

import Thumbnail from 'components/Thumbnail';

import styles from './styles.module.scss';

const Heading = ({ title, thumbnailFile }) => (
	<div className={styles.Heading}>
		{thumbnailFile && (
			<Thumbnail
				file={thumbnailFile}
				params={{ width: 80, height: 80 }}
				className={styles.Heading__Image}
			/>
		)}
		<h1 className={styles.Heading__Title}>{title}</h1>
	</div>
);

Heading.propTypes = {
	title: PropTypes.string.isRequired,
	thumbnailFile: FilePropType
};

export default Heading;
